module.exports = __webpack_public_path__ + "static/img/0_0_0.b776541b.jpg";